module.exports = __webpack_public_path__ + "img/img5.add99568.svg";